import React, { useState } from 'react';

const VumaQash = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: "👥",
      title: "Affiliate Marketing",
      description: "Earn commissions on 3 levels by sharing your referral link",
      color: "from-blue-500 to-cyan-500",
      bgColor: "bg-gradient-to-br from-blue-500/10 to-cyan-500/10",
      borderColor: "border-blue-500/20"
    },
    {
      icon: "📺",
      title: "YouTube Videos",
      description: "Get paid for watching promotional YouTube videos",
      color: "from-red-500 to-pink-500",
      bgColor: "bg-gradient-to-br from-red-500/10 to-pink-500/10",
      borderColor: "border-red-500/20"
    },
    {
      icon: "🎵",
      title: "TikTok Videos",
      description: "Earn money watching engaging TikTok content",
      color: "from-purple-500 to-indigo-500",
      bgColor: "bg-gradient-to-br from-purple-500/10 to-indigo-500/10",
      borderColor: "border-purple-500/20"
    },
    {
      icon: "🎬",
      title: "Netflix Ads",
      description: "Get paid for interacting with Netflix advertisements",
      color: "from-red-600 to-rose-500",
      bgColor: "bg-gradient-to-br from-red-600/10 to-rose-500/10",
      borderColor: "border-red-600/20"
    },
    {
      icon: "🧠",
      title: "Trivia Questions",
      description: "Answer questions correctly and earn instant rewards",
      color: "from-green-500 to-emerald-500",
      bgColor: "bg-gradient-to-br from-green-500/10 to-emerald-500/10",
      borderColor: "border-green-500/20"
    },
    {
      icon: "📱",
      title: "Data & Airtime",
      description: "Earn from selling discounted data and airtime",
      color: "from-teal-500 to-cyan-500",
      bgColor: "bg-gradient-to-br from-teal-500/10 to-cyan-500/10",
      borderColor: "border-teal-500/20"
    },
    {
      icon: "📈",
      title: "Follower Gains",
      description: "Grow your social media presence and earn",
      color: "from-blue-600 to-indigo-500",
      bgColor: "bg-gradient-to-br from-blue-600/10 to-indigo-500/10",
      borderColor: "border-blue-600/20"
    },
    {
      icon: "🏆",
      title: "Tournaments",
      description: "Compete in challenges and win exciting prizes",
      color: "from-yellow-500 to-amber-500",
      bgColor: "bg-gradient-to-br from-yellow-500/10 to-amber-500/10",
      borderColor: "border-yellow-500/20"
    },
    {
      icon: "💹",
      title: "Forex Signals",
      description: "Access advanced Forex trading signals",
      color: "from-green-600 to-lime-500",
      bgColor: "bg-gradient-to-br from-green-600/10 to-lime-500/10",
      borderColor: "border-green-600/20"
    },
    {
      icon: "🎁",
      title: "Welcome Bonus",
      description: "Receive instant bonus upon registration",
      color: "from-pink-500 to-rose-500",
      bgColor: "bg-gradient-to-br from-pink-500/10 to-rose-500/10",
      borderColor: "border-pink-500/20"
    }
  ];

  const earningsStats = [
    { value: "$373", label: "Potential Daily", sublabel: "Earnings" },
    { value: "10", label: "Income", sublabel: "Streams" },
    { value: "4,832+", label: "Active", sublabel: "Members" },
    { value: "98%", label: "Success", sublabel: "Rate" }
  ];

  return (
    <section className="vumaqash py-20 md:py-32 bg-gradient-to-br from-slate-900 via-gray-900 to-purple-900 relative overflow-hidden" id="vumaqash">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/5 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-cyan-500/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6 shadow-lg shadow-blue-500/25">
            <span className="h-2 w-2 bg-white rounded-full animate-pulse"></span>
            <span>10 INCOME STREAMS</span>
            <span className="h-2 w-2 bg-white rounded-full animate-pulse animation-delay-1000"></span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-white via-blue-400 to-purple-400 bg-clip-text text-transparent">
            VumaQash Agencies
            <span className="block text-2xl md:text-3xl text-gray-300 mt-4">Your Gateway to Financial Freedom</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Unlock multiple income streams with just one activation. Work from anywhere, build your legacy, and achieve the financial freedom you deserve.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="flex flex-col lg:flex-row items-start gap-12 mb-20">
          {/* Left Column - Info Card */}
          <div className="lg:w-1/2">
            <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-xl p-8 rounded-3xl border border-gray-700/50 shadow-2xl relative overflow-hidden group hover:border-blue-500/30 transition-all duration-500">
              {/* Background Pattern */}
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/5 via-transparent to-purple-500/5"></div>
              
              <div className="relative z-10">
                <h3 className="text-3xl font-bold mb-6 bg-gradient-to-r from-white to-blue-400 bg-clip-text text-transparent">
                  What is VumaQash?
                </h3>
                <p className="text-gray-300 text-lg mb-6 leading-relaxed">
                  VumaQash is a revolutionary platform that provides <span className="text-blue-400 font-semibold">10 different ways to earn money online</span> while enjoying the convenience and flexibility of working from home or anywhere you choose.
                </p>
                
                <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                  With just a <span className="text-green-400 font-semibold">one-time activation fee</span>, you gain access to multiple income streams that can help you build sustainable wealth.
                </p>
                
                {/* Benefits Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  {[
                    "🚀 No prior experience needed",
                    "🎭 Work anonymously",
                    "💎 Multiple income streams",
                    "🛡️ 24/7 support & training",
                    "🌍 Global community",
                    "📱 Mobile-friendly platform"
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-center space-x-3 text-gray-300 group">
                      <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
                      <span className="group-hover:text-white transition-colors duration-300">{benefit}</span>
                    </div>
                  ))}
                </div>
                
                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <a 
                    href="https://wa.me/254115272510?text=Hey%20Cleophas,%20I'm%20interested%20in%20VumaQash%20Agencies" 
                    className="group relative bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-green-500/25 hover:shadow-green-500/40 flex items-center justify-center space-x-3"
                  >
                    <span className="text-xl">💬</span>
                    <span>Join Now</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                  
                  <a 
                    href="https://t.me/CLEOPHAS_MWK" 
                    className="group relative bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-blue-500/25 hover:shadow-blue-500/40 flex items-center justify-center space-x-3"
                  >
                    <span className="text-xl">⚡</span>
                    <span>Fast Activation</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right Column - Features Grid */}
          <div className="lg:w-1/2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className={`${feature.bgColor} backdrop-blur-sm p-6 rounded-2xl border ${feature.borderColor} shadow-xl transform transition-all duration-500 hover:scale-105 hover:shadow-2xl cursor-pointer group ${
                    activeFeature === index ? 'ring-2 ring-blue-500/50 scale-105' : ''
                  }`}
                  onMouseEnter={() => setActiveFeature(index)}
                  onClick={() => setActiveFeature(index)}
                >
                  <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center text-2xl text-white mb-4 shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
                    {feature.icon}
                  </div>
                  <h3 className="font-bold text-lg mb-2 text-white group-hover:text-blue-400 transition-colors duration-300">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                    {feature.description}
                  </p>
                  
                  {/* Hover Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Earnings Potential Section */}
        <div className="bg-gradient-to-r from-blue-600/90 to-purple-700/90 backdrop-blur-xl rounded-3xl p-12 text-white text-center relative overflow-hidden shadow-2xl">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/10 via-transparent to-white/5"></div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-white to-cyan-300 bg-clip-text text-transparent">
              Transform Your Earnings
            </h3>
            <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto">
              Join thousands of members who have already started their journey to financial independence
            </p>
            
            {/* Stats Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
              {earningsStats.map((stat, index) => (
                <div 
                  key={index}
                  className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 transform transition-all duration-500 hover:scale-105 hover:bg-white/15 group"
                >
                  <div className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-white to-cyan-300 bg-clip-text text-transparent group-hover:from-yellow-300 group-hover:to-amber-400 transition-all duration-500">
                    {stat.value}
                  </div>
                  <div className="text-blue-100 font-semibold">{stat.label}</div>
                  <div className="text-blue-200 text-sm">{stat.sublabel}</div>
                  
                  {/* Animated Dot */}
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mx-auto mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-ping"></div>
                </div>
              ))}
            </div>
            
            {/* Enhanced CTA */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="https://wa.me/254115272510?text=Hey%20Cleophas,%20I%20want%20to%20learn%20about%20earning%20potential%20with%20VumaQash" 
                className="group relative bg-white text-blue-600 font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-white/25 flex items-center space-x-3"
              >
                <span className="text-xl">📊</span>
                <span>View Full Earnings Breakdown</span>
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </a>
              
              <a 
                href="https://www.vumaqash.com/user/register.php?ref=CLEOPHAS"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-600 hover:to-amber-700 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-yellow-500/25 hover:shadow-yellow-500/40 flex items-center space-x-3"
              >
                <span className="text-xl">⚡</span>
                <span>Register Instantly</span>
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </a>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-12 text-gray-400">
            <div className="flex items-center space-x-3">
              <span className="text-green-500 text-xl">🛡️</span>
              <span>Secure & Trusted Platform</span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-blue-500 text-xl">🌍</span>
              <span>Global Community</span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-purple-500 text-xl">💎</span>
              <span>Proven Success</span>
            </div>
          </div>
        </div>
      </div>

      {/* Add custom animations */}
      <style jsx>{`
        .animation-delay-1000 {
          animation-delay: 1000ms;
        }
      `}</style>
    </section>
  );
};

export default VumaQash;